import React from 'react';

import SalesChannelsEdit from '@components/shared/sales_channels/SalesChannelsEdit';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';

import { inventoryTypeService } from '@services/admin/inventoryTypeService';
import { shippingTypeService } from '@services/admin/shippingTypeService';
import { salesChannelService } from '@services/admin/salesChannelService';

const AdminSalesChannelsNew: React.FC = () => {
  const { inventoryTypes, shippingTypes, loading } = useMerchantData()!;

  return (
    <SalesChannelsEdit
      role="admin"
      isNew={true}
      salesChannelService={salesChannelService}
      inventoryTypeService={inventoryTypeService}
      shippingTypeService={shippingTypeService}
      inventoryTypes={inventoryTypes}
      shippingTypes={shippingTypes}
      merchantDataLoading={Boolean(loading)}
    />
  );
};

export default AdminSalesChannelsNew;
